module.exports = __webpack_public_path__ + "img/RECSTATION_logo.4ee76e52.png";